"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLoggerAPI = void 0;
var index_1 = require("./index");
var constants_1 = require("./constants");
/**
 * The public Logger utility API exposed via SplitFactory, used to update the log level.
 *
 * @param log the factory logger instance to handle
 */
function createLoggerAPI(log) {
    function setLogLevel(logLevel) {
        if ((0, index_1.isLogLevelString)(logLevel)) {
            log.setLogLevel(logLevel);
        }
        else {
            log.error(constants_1.ERROR_LOGLEVEL_INVALID);
        }
    }
    return {
        /**
         * Enables all the logs.
         */
        enable: function () {
            setLogLevel(index_1.LogLevels.DEBUG);
        },
        /**
         * Sets a custom log Level for the SDK.
         * @param {string} logLevel - Custom LogLevel value.
         */
        setLogLevel: setLogLevel,
        /**
         * Disables all the log levels.
         */
        disable: function () {
            // Disabling is equal logLevel none
            setLogLevel(index_1.LogLevels.NONE);
        },
        /**
         * Exposed for usage with setLogLevel
         */
        LogLevel: index_1.LogLevels
    };
}
exports.createLoggerAPI = createLoggerAPI;
